import React, { useState, useEffect } from "react";
import {
  Button,
  Card,
  Form,
  Container,
  Col,
  Row
} from "react-bootstrap";
import companyLogoURL from "../../assets/img/baolinPrivate/logo-baolin-header-removebg-preview.png";
// import Wizard from "../Forms/Wizard/RegisterWizard/RegisterWizard"
// import { useUser } from "../../security/UserContext";
// import { useHistory } from "react-router-dom";
import ChingMingEventCarousels from "./ChingMingEventCarousels/index";
import Guest from "../../layouts/Guest";

function GuestPage() {

  return (
    <>
      <Guest>
        <ChingMingEventCarousels />
      </Guest>
    </>
  );
}

export default GuestPage;
